/** @format */

import { ProductListContainerComponent } from './product-list/product-list-container/product-list-container.component';
import { ProductListPageResolveGuard } from './guards/product-list-page-resolve.guard';
import { Routes } from '@angular/router';
import { SearchResultsListPageResolveGuard } from './guards/search-results-list-page-resolve.guard';

// /*
//  * Standalone App Routes
//  */
export const PRODUCT_LIST_APP_ROUTES: Routes = [
	{
		path: 'f/:seoToken',
		component: ProductListContainerComponent,
		providers: [ProductListPageResolveGuard],
		resolve: { productList: ProductListPageResolveGuard }
	},
	{
		path: 'search/SearchDisplay',
		component: ProductListContainerComponent,
		providers: [SearchResultsListPageResolveGuard],
		resolve: { productList: SearchResultsListPageResolveGuard }
	}
];
